module.exports = __webpack_public_path__ + "img/about1.a2fffa67.jpg";